export function capitalize(text) {
  return text.toLowerCase().replace(/(?:^|\s)\S/g, a => a.toUpperCase())
}

export default capitalize
